// Development shows the work-in-progress registration at its canonical route.
// Production requires an explicit release flag; "false" also permits local legacy tests.
export function isNewRegistrationEnabled(env = process.env) {
  if (env.REACT_APP_ANNUAL_REGISTRATION_ENABLED !== undefined) {
    return env.REACT_APP_ANNUAL_REGISTRATION_ENABLED === 'true';
  }
  return env.NODE_ENV === 'development';
}
